import { type } from "os";

export interface State {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
}

// Create a schema representation of the interface
export const StateSchema = {
  name: 'State',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    code: { type: 'string' }
  }
};
